import {createReducer} from "./index";
import * as R from 'ramda';
import {convertToDate} from "../projections";
import {ADD_PROJECTS, REMOVE_PROJECT} from "../actions/projects";

/*
Structure of projects model:

{
  data: {
    [uuid]: {
      permissions: {
        // these are returned by the backend; may not be up to date
        view: bool
        update: bool
        delete: bool
        create_submittal: bool
        create_projectrfi: bool
        create_task: true
        create_punchlistitem: true
        create_dailylog: true
      }
      resource: {
        // these are returned by the backend; may not be up to date
        id: string // uuid
        parentprojectid: string // uuid
        name: string // project name
        number: string // the internal number
        address: string
        address2: string
        city: string
        state: string
        zip: string
        siteopened: bool
        estimatedcompletiondate:
        contractsize:
        createdbyuserid: string // uuid
        owneruserid: string // uuid
        createdbycompanyid: string // uuid
        ownercompanyid: string // uuid
        active: bool
        country: string
        status: string // code-driven code_projectstatus
        customername: string
        architectname: string
        csicodes: array of string // code-driven code_csi
        dateopened: datetime
        datecreated: datetime
        description: string
        newconstruction: bool
        union: bool
        certifiedpayroll: bool
        prevailingwage: bool
        ccipinsurance: bool
        industries: array of string // code-driven code_industry
        sectors: array of string // code-driven code_sector
        setasides: array of string // code-driven code_setaside
        abbreviation: string
        internalnumber: string
      }
    }
  }
  indexes: {
    // used for indexing entries by different fields other than the id field
  }

}
 */

const projectsInitial = {
  data: {},
  indexes: {},
  inflight: {},
};

const projectsReducer = createReducer(projectsInitial, {
  // 'ACTION_NAME': function (state, action) -> new_state
  [ADD_PROJECTS]: (state, action) => {
    let newState = state;
    action.payload.forEach(project => {
      project.resource.dateopened = convertToDate(project.resource.dateopened);
      project.resource.datecreated = convertToDate(project.resource.datecreated);
      newState = R.over(R.lensPath(['data', project.resource.id]), () => project)(newState);
    });
    return newState;
  },
  [REMOVE_PROJECT]: (state, action) => {
    const { projectId } = action.payload;
    return R.dissocPath(['data', projectId], state);
  },
});

export default projectsReducer;



// WEBPACK FOOTER //
// ./src/reducers/projects.js